import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistorySection from 'Components/HistorySection';
import { formatPartialDate } from 'Utility/date';
import { getPatientAgeInMonthsWithOneDecimal } from 'Utility/patientInfo';
import { showPatientAgeInMonthsOnForm } from '../../utils';
import InfoPopover from 'Components/InfoPopover';
import HistoryRowListing from 'Components/HistoryRowListing';
import { Item } from 'Components/Grid';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import { rulm } from 'neuro-schemas';

const { calculateScore } = rulm;

const RULM = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'motor.rulm'} />}
      newButton={
        <DocumentCreationButton
          name="rulm"
          text={'motor.newRULM'}
          onClick={startEdit({}, 'rulm')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id={'general.date'} />
            </Item>
            <Item xs={4}>
              <FormattedMessage id={'motor.rulmScoreRight'} />
            </Item>
            <Item xs={6}>
              <FormattedMessage id={'motor.rulmScoreLeft'} />
            </Item>
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={2} id={'rulmDate'}>
              {showPatientAgeInMonthsOnForm(d.date) ? (
                <FormattedMessage
                  id="motor.dateAndMonth"
                  values={{
                    date: formatPartialDate(d.date),
                    months: getPatientAgeInMonthsWithOneDecimal(d.date),
                  }}
                />
              ) : (
                formatPartialDate(d.date)
              )}
            </Item>
            <Item xs={4} id={'rulmRightScore'}>
              {calculateScore(d, 'Right') === null ? (
                <InfoPopover text="general.notFilled" color="primary" />
              ) : (
                calculateScore(d, 'Right')
              )}
            </Item>
            <Item xs={4} id={'rulmLeftScore'}>
              {calculateScore(d, 'Left') === null ? (
                <InfoPopover text="general.notFilled" color="primary" />
              ) : (
                calculateScore(d, 'Left')
              )}
            </Item>
          </>
        )}
        makeControls
        historyRowControls={d => (
          <div id={'rulmHistoryControl'}>
            <HistoryRowControls document={d} startEdit={startEdit} view={view} />
          </div>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'rulm'>[];
  startEdit: StartEdit;
  view?: IView;
}

export default RULM;
